import { Stack, Text } from '@chakra-ui/react';
import palette from '@theme/assets/palette';
import { FC } from 'react';

interface Props {
    title: string;
}

const BigSectionTitleComponent: FC<Props> = ({ title }) => {
    return (
        <Stack
            paddingTop="30px"
            paddingBottom="20px"
            alignSelf="stretch"
            direction="row"
            justify="center"
            align="center"
            spacing="10px"
        >
            <Text variant="titleXL" color={palette.ui02} flex="1" textAlign="center">
                {title}
            </Text>
        </Stack>
    );
};

export default BigSectionTitleComponent;
